export const delimiters = {
  comma: ',',
  semicolon: ';'
}
